export enum MSOfficeDesktopCheckboxFields {
    M365_SUBSCRIBED = 'M365Subscribed',
    M365_INSTALLED = 'M365Installed',
    M365_SIGNED_IN = 'M365SignedIn',
}

export const MS_OFFICE_DESKTOP = 'mswopibeta';
